var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatarGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D7D7DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0539 26.2902C26.0572 26.4918 26.0539 26.6934 26.0458 26.8934C26.0343 27.1328 26.0097 27.3869 25.8638 27.5754C25.6638 27.8328 25.3048 27.8918 24.9802 27.9213C24.0425 28.0066 23.0999 28.0016 22.1589 27.9984C19.9277 27.9885 17.6966 27.9803 15.4654 27.9705C14.9343 27.9689 14.4031 27.9656 13.8753 27.9131C13.6392 27.8902 13.3884 27.8475 13.2179 27.6836C12.872 27.3525 13.0015 26.6246 12.9933 26.1918C12.9835 25.5803 13.0835 24.9475 13.2212 24.3525C13.4966 23.1607 14.0261 22.0197 14.8179 21.082C16.0064 19.6721 17.8113 18.7541 19.6539 18.7934C21.5703 18.8361 23.3917 19.9115 24.5244 21.459C25.5376 22.8443 26.0261 24.5689 26.0539 26.2885V26.2902Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3654 17.4803C21.4392 17.4853 23.131 15.8082 23.1326 13.7459C23.1343 11.682 21.449 10.0033 19.3736 10C17.2999 9.99673 15.608 11.6754 15.6064 13.7377C15.6064 15.8033 17.2851 17.4754 19.3654 17.482V17.4803Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0326 25.4279C32.0277 25.4459 32.0228 25.4623 32.0179 25.4803C31.9392 25.7639 31.8146 26.0525 31.5654 26.2033C31.3539 26.3295 31.0949 26.3344 30.8474 26.3344C29.5785 26.3361 28.308 26.3377 27.0392 26.3393V26.2902C27.0392 23.6754 25.9933 21.3377 24.349 19.7803C26.0605 18.7131 28.4162 18.782 30.0572 19.959C31.7326 21.159 32.5539 23.4344 32.0326 25.4279Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1376 18.3869C28.7441 18.3934 30.0736 17.0803 30.0753 15.4836C30.0785 13.8787 28.7687 12.5672 27.1572 12.5623C25.5507 12.5574 24.2212 13.8672 24.213 15.4639C24.2048 17.0525 25.5326 18.3803 27.1376 18.3885V18.3869Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15559 25.4279C7.16051 25.4459 7.16543 25.4623 7.17034 25.4803C7.24903 25.7639 7.37362 26.0525 7.6228 26.2033C7.83428 26.3295 8.09329 26.3344 8.34083 26.3344C9.60969 26.3361 10.8802 26.3377 12.149 26.3393V26.2902C12.149 23.6754 13.1949 21.3377 14.8392 19.7803C13.1277 18.7131 10.772 18.782 9.131 19.959C7.45559 21.159 6.63428 23.4344 7.15559 25.4279Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0507 18.3869C10.4441 18.3934 9.11461 17.0803 9.11297 15.4836C9.10969 13.8787 10.4195 12.5672 12.031 12.5623C13.6376 12.5574 14.9671 13.8672 14.9753 15.4639C14.9835 17.0525 13.6556 18.3803 12.0507 18.3885V18.3869Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarGroup);
export default __webpack_public_path__ + "static/media/default_avatar_group.07bfbd171a1690b4b42ff62506202c56.svg";
export { ForwardRef as ReactComponent };